module.exports = __webpack_public_path__ + "img/square-half.c6105f78.svg";